import { shape, string } from "prop-types";

const FacebookNewsfeedDataPropTypes = shape({
  body: string,
  title: string,
  message: string,
  domain: string
});

export default FacebookNewsfeedDataPropTypes;
